import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { TextMaskModule } from 'angular2-text-mask';

@Injectable()
export class ConfigsService {
    local_config = '_FC_CONFIG'; //informações de sessão

    endpoint = environment.apiUrl;
    mask_hora: TextMaskModule = [ /[0-9]/, /\d/, ':', /[0-9]/, /\d/];

    getConfig(chave) { //chave do objeto. Ex.: chave = 'nome' Retorno: config.nome
        return new Promise((resolve, reject) => {
            let config = localStorage.getItem(this.local_config)
            if (config != null) {
                let retorno = chave ? config[chave] : config;
                resolve(retorno);
            }
            else {
                reject(null);
            }
        });
    }

    getEndpoint() {
        return this.endpoint;
    }

    _SQLDateToDate(data, mascara) {
        if (data == "" || data == null) {
            return ""
        }

        if (mascara == "DD/MM/YYYY") {
            var dt = data.split("-")
            return (dt[2] + "/" + dt[1] + "/" + dt[0])
        }

        if (mascara == "DD/MM/YYYY HH:mm:ss") {
            var dt = data.split("-")
            var hora = data.split(" ")
            return (dt[2].split(' ')[0] + "/" + dt[1] + "/" + dt[0] + " " + hora[1])
        }

        if (mascara == "MM/DD/YYYY") {
            var dt = data.split("-")
            return (dt[1] + "/" + dt[2] + "/" + dt[0])
        }
    }

    _dateToSQL(date){
        return date.getFullYear() + '-' + (Number(date.getMonth()) + 1) + '-' + date.getDate()
    }
}